export default __webpack_public_path__ + "static/media/CaretDown_2.aa2075cb.svg";